import jsPDF from "jspdf";
import { Orders } from "../models/Orders";

function formatDate(dateInput: Date | string): string {
    const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = String(d.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
}

export class LabelsService {
    /**
     * Генерация PDF с этикетками в браузере (1 короб = 1 страница).
     */
    static downloadOrderLabels(order: Orders) {
        if (!order?.boxes?.length) return;

        // размеры в мм
        const labelWmm = 60;
        const labelHmm = 40;
        const borderMm = 3;

        const totalBoxes = order.boxes.reduce((sum: number, b: any) => sum + (b.amount ?? 0), 0);
        let counter = 1;

        const pdf = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: [labelWmm + borderMm * 2, labelHmm + borderMm * 2],
        });

        for (let i = 0; i < order.boxes.length; i++) {
            const amount = order.boxes[i].amount ?? 0;

            for (let j = 1; j <= amount; j++) {
                if (counter > 1) {
                    pdf.addPage([labelWmm + borderMm * 2, labelHmm + borderMm * 2], "landscape");
                }

                // фон
                pdf.setFillColor(228, 228, 228);
                pdf.rect(0, 0, labelWmm + borderMm * 2, labelHmm + borderMm * 2, "F");

                // белая область
                pdf.setFillColor(255, 255, 255);
                pdf.roundedRect(borderMm, borderMm, labelWmm, labelHmm, 3, 3, "F");

                // ⚠️ Roboto может отсутствовать в jsPDF без встраивания шрифта.
                // Если увидишь ошибки — замени на "helvetica".
                try {
                    pdf.setFont("Roboto", "normal");
                } catch {
                    pdf.setFont("helvetica", "normal");
                }

                pdf.setFontSize(15);
                pdf.setTextColor(0, 0, 0);

                const linesRaw = [
                    { text: order.entity ?? "", bold: false },
                    { text: order.sendCity ?? "", bold: true },
                    { text: order.departureDate ? formatDate(order.departureDate) : "", bold: true },
                    { text: `Короб ${counter}/${totalBoxes}`, bold: false },
                ];

                const maxTextWidth = labelWmm - 4;
                const wrappedLines = linesRaw.flatMap((lineObj) => {
                    const chunks = pdf.splitTextToSize(lineObj.text, maxTextWidth);
                    return chunks.map((c: any) => ({ text: c, bold: lineObj.bold }));
                });

                const lineHeight = 6;
                let currentY = borderMm + (labelHmm - wrappedLines.length * lineHeight) / 2 + 4;

                wrappedLines.forEach(({ text, bold }) => {
                    try {
                        pdf.setFont("Roboto", bold ? "bold" : "normal");
                    } catch {
                        pdf.setFont("helvetica", bold ? "bold" : "normal");
                    }

                    pdf.text(text, labelWmm / 2 + borderMm, currentY, { align: "center" });
                    currentY += lineHeight;
                });

                counter++;
            }
        }

        const fileName = `${order.sendCity ?? "labels"}_${order.departureDate ? formatDate(order.departureDate) : ""}.pdf`;
        pdf.save(fileName);
    }
}
